export default function getCommentDecoratorId(id) {
  return "comment_decorator_".concat(id);
}